import React, { Component } from 'react';
import { AppSwitch } from '@coreui/react';
import { Translation } from "react-i18next";

function translate(key) {
    return (
        <Translation>{(t, { i18n }) => t(key)}</Translation>
    );
}
class SelectElevation extends Component {
    render() {
        if (!this.props.isElevationToggleVisible) {
            return null;
        }
        return (
            <div className="flexContainer float-right ">
                <b className="text-secondary mr-2"> {translate('elevation')} </b>
                <AppSwitch className={'lx-1 zIndexZero'}
                    id='elevation'
                    color='primary'
                    label={true}
                    dataOn={'\u2713'}
                    dataOff={'\u2715'}
                    size='lg'
                    checked={this.props.elevationState}
                    onChange={(e) => this.props.onClick(e.target.checked) || null}
                />
            </div>
        );
    }
}

export default SelectElevation;